import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const TextHtmlEditor = ({ id, value, onChange, className }) => {
  return (
    <ReactQuill
      id={id}
      theme="snow"
      value={value ?? ""}
      onChange={(content) => onChange?.(content)}
      className={className}
      modules={{
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: [] }],
          ["link"],
          ["clean"],
        ],
      }}
      formats={[
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "align",
        "link",
      ]}
    />
  );
};

export default TextHtmlEditor;
